import { Store } from "vuex";
import { Tutorial } from "@/lib/models/tutorial";

/**
 * ホームのオンボーディングスライド (HomeIntroSlides) 表示用レコードを作成する。
 * リリース以降にサインアップ / 初回連携ログインしたユーザーの目印として利用される。
 */
export async function createHomeIntroSlidesTutorial(store: Store<unknown>): Promise<void> {
  const tutorial: Tutorial = {
    screen: "home",
    category: "introSlides",
    step: "before",
  };
  await store.dispatch("tutorialModule/createTutorial", { tutorial });
}
